<template>
<div v-if="onboardingPercentageValue !== 100" class="flex flex-col gap-3">
	<div class="text-body-sm">
		<div class="mb-0.5 text-sm font-bold" v-text="`Cześć, ${userStore.firstName}`"/>
		Twoja wizytówka ma&nbsp;znaczenie. Uzupełnij&nbsp;ją i&nbsp;zdobywaj nowych&nbsp;klientów.
	</div>

	<div class="flex flex-col gap-2 rounded-lg bg-accent-50 px-3 py-4">
		<div class="flex items-center justify-between text-body-sm">
			Profil uzupełniony:
			<div class="font-bold text-accent-600" v-text="`${onboardingPercentageValue}%`"/>
		</div>
		<OProgressBar :modelValue="onboardingPercentageValue" :max="100" :displayLabels="false"/>
	</div>

	<OButton v-if="displayButton" size="sm" fullWidth="true" label="Uzupełnij profil" @click="goToOnboarding()"/>
</div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { OProgressBar } from 'ofe-common/components';
import { useUserStore } from '@globals/stores/user';
import { useCustomerOnboardingStore } from '@customer/stores/customerOnboarding';

const userStore = useUserStore();
const customerOnboardingStore = useCustomerOnboardingStore();

defineProps<{
	displayButton: boolean;
}>();

const { onboardingPercentageValue } = storeToRefs(customerOnboardingStore);
customerOnboardingStore.getOnboardingSteps();

function goToOnboarding() {
	document.location.href = '/konto/onboarding';
}
</script>
